import React from 'react';
import { FormBase } from '../Interface';
import { useProjectTasks } from '../../hooks/useProjectTasks';
import { ProjectTaskReports } from './ProjectTaskReports';
import { ProjectTaskPage } from './ProjectTaskPage';

export const ProjectTaskMain = () => {
  const projectTasksState = useProjectTasks();

  const {
    refetchTable,
    setRefetchTable,
    viewField,
    operatorsDisabled,
    rowSelectionModel,
    setRowSelectionModel,
    autocompleteOptions,
    selectedValues,
    setSelectedValues,
    autocompleteData,
    jokerFields,
    submenuNames,
  } = projectTasksState;

  return (
    <FormBase
      name="ProjectTasks"
      leftPanelContent={<ProjectTaskPage projectTasksState={projectTasksState} />}
      rightPanelContent={
        <ProjectTaskReports
          refetch={{ refetchTable, setRefetchTable }}
          values={{ selectedValues, setSelectedValues }}
          viewField={viewField}
          operatorsDisabled={operatorsDisabled}
          rowSelection={{ rowSelectionModel, setRowSelectionModel }}
          autocompleteOptions={autocompleteOptions}
          autocompleteData={autocompleteData}
          jokerFields={jokerFields}
          submenuNames={submenuNames}
        />
      }
    />
  );
};

export default ProjectTaskMain;
